import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import MemorizedSidebar from './components/sidebar/sidebar';

const useAuth = () => {
    const { userId, loading, error } = useSelector((state) => state.auth);
    if (userId) {
        return true
    } else {
        return false
    }
}

const ProtectedRoutes = ({ handleNCClick }) => {
    const auth = useAuth()

    const NCCallBack = (applicationId) => {
        handleNCClick(applicationId)
    }

    return auth ?
        <div style={{ display: 'flex' }}>
            <MemorizedSidebar handleCallBack={NCCallBack} />
            <Outlet />
        </div>
        : <Navigate to="/" />
}
export default ProtectedRoutes;